import { Offcanvas } from "react-bootstrap";
import BasketHeader from "./BasketHeader";
import Footer from "./Footer";
import React, { useContext } from "react";
import CardItemContext from "../../../../context/CardItem/CardItemContext";

const Basket = () => {
  const { basketData, showOffcanvas, setShowOffcanvas } =
    useContext(CardItemContext);

  return (
    basketData && (
      <Offcanvas
        className="basket"
        style={{ maxWidth: "475px", width: "100%" }}
        show={showOffcanvas}
        onHide={(e) => setShowOffcanvas((prev) => !prev)}
        placement="end"
      >
        <Offcanvas.Header
          className="border-bottom border-2"
          closeButton
          style={{ direction: "rtl" }}
        >
          <Offcanvas.Title className="rd-8 bg-primary bg-opacity-75 text-white d-flex justify-content-center align-items-center font-14-500 wh-32">
            <span>{basketData?.list?.length}</span>
          </Offcanvas.Title>
          <Offcanvas.Title style={{ fontSize: "16px", fontWeight: "600" }}>
            سبد خرید
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            padding: "0px",
          }}
        >
          <BasketHeader />
          <Footer />
        </Offcanvas.Body>
      </Offcanvas>
    )
  );
};

export default Basket;
